import listingFiltersConstants from '../constants/filters/listingFiltersConstants';
import listingFiltersTypesConstants from '../constants/filters/listingFiltersTypesConstants.js';

let processId = 0;

const parseFilters = (route) => {
  const { filters } = route.query;
  
  if (!filters) {
    return [];
  }

  try {
    const parsed = JSON.parse(filters);

    if (!Array.isArray(parsed)) {
      console.error('Filters invalid type. Expected instance of Array.', parsed);
      return [];
    }

    return parsed;
  } catch {
    return [];
  }
};

const displayValue = (inputType, items, value) => {
  if (inputType === listingFiltersTypesConstants.TEXT_SEARCH_TYPE) {
    return value;
  }

  if (inputType === listingFiltersTypesConstants.RANGE_TYPE) {
    return `${ value?.fromVal ? 'od ' + value.fromVal : '' } ${ value?.toVal ? ' do ' + value.toVal : '' }`;
  }

  if (inputType === listingFiltersTypesConstants.MULTI_SELECT_TYPE) {
    const arrayOfFilters = items.filter((item) => value?.includes(item.value));
    if (!arrayOfFilters) {
      return undefined;
    }
    return arrayOfFilters.map(({ label }) => label)?.join(', ');
  }

  const item = items.find((item) => item.value === value);

  if (!item) {
    return undefined;
  }

  return item.label;
};

const createConfig = () => {
  const config = {};

  listingFiltersConstants.forEach(({ path, filters }) => {
    config[path] = {};

    filters.forEach((item) => {
      config[path][item.key] = {
        getItems: async () => [],
        ...item,
        isInit: false,
        items: [],
      };
    });
  });

  return config;
};


const state = {
  config: {},
  filters: {},
  sidebarActive: false,
};

const getters = {
  notEmptyFilters: (state) => () => {
    return Object.keys(state.filters)
      .map((key) => state.filters[key])
      .filter(({ value }) => typeof value === 'string'
        || typeof value === 'number'
        || (typeof value === 'object' && (value?.fromVal || value?.toVal))
        || Array.isArray(value),
      )
      .filter(({ value }) => value !== '');
  },
  routeConfig: (state) => (route) => {
    const routeConfig = matchRoutePath(state.config, route.path);
    return Object.keys(routeConfig).map((key) => routeConfig[key]);
  },
};

function matchRoutePath(paths_list, path_search, returnPath = false) {
  const cleanPath = path_search.split('?')[0];
  for (const path of Object.keys(paths_list)) {
    if (!path) {
      continue;
    }

    const regex = new RegExp('^' + path.replace(/:[^/]+/g, '[^/]+') + '$');
    if (regex.test(cleanPath)) {
      if (returnPath) {
        return path;
      }

      return paths_list[path];
    }
  }

  return {};
}

const actions = {
  open({ commit }) {
    commit('sidebarActive', true);
  },
  close({ commit }) {
    commit('sidebarActive', false);
  },

  clear({ commit }) {
    commit('setFilters', {
      config: {},
      filters: {},
    });
  },

  async setRoute({ commit, state }, route) {
    const currProcessId = ++processId;
    const config = Object.keys(state.config).length ? state.config : createConfig();
    const filters = {};
    const parsedFilters = parseFilters(route);

    parsedFilters.forEach(({ field, value }) => {
      filters[field] = { field, value };
    });

    const pathConfig = {};
    let hasChanges = false;

    const matchPath = matchRoutePath(config, route.path);
    const promises = Object.keys(matchPath).map(async (key) => {
      const filterConfig = (matchPath[key] || {});
      let configItem = { ...filterConfig };
      let items = await filterConfig.items;
      if (!filterConfig.isInit) {
        items = await filterConfig.getItems();
        hasChanges = true;
        configItem.isInit = true;
        configItem.items = items;
      }

      filters[key] = {
        key: key,
        badge: filterConfig.badge,
        inputType: filterConfig.inputType,
        placeholder: filterConfig.placeholder,
        displayValue: displayValue(filterConfig.inputType, items, (filters[key] || {}).value),
        items,
        disabled: filterConfig?.disabled || false,
        ...(filters[key] || {}),
      };

      pathConfig[key] = configItem;
    });

    const rejectedFilters = (await Promise.allSettled(promises)).filter(({ status }) => 'rejected' === status);

    if (rejectedFilters.length) {
      console.error('Unable to load filters.', rejectedFilters);
    }

    let newConfig = config;
    if (hasChanges) {
      newConfig = {
        ...config,
        ...{
          [matchRoutePath(config, route.path, true)]: pathConfig,
        },
      };
    }

    if (currProcessId !== processId) {
      commit('setConfig', {
        config: newConfig,
      });
    } else {
      commit('setFilters', {
        config: newConfig,
        filters,
      });
    }
  },
};

const mutations = {
  sidebarActive(state, value) {
    state.sidebarActive = value;
  },

  setFilters(state, { config = {}, filters = {} }) {
    state.config = config;
    state.filters = filters;
  },

  setConfig(state, { config = {} }) {
    state.config = config;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
